import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setIsChangeCustomTrigger: Function // function to toggle custom trigger
    setChangeCustomTriggerId: Function // function to set custom trigger Id
}

// component to render widget custom trigger
const CustomTrigger = (props: PropTypes) => {

    // Props
    const { setIsChangeCustomTrigger, setChangeCustomTriggerId } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();

    // Stets
    const [customTrigger, setCustomTrigger] = useState<boolean>(false);
    const [customTriggerId, setCustomTriggerId] = useState<string>(currentWebsite && currentWebsite.custom_trigger_id || '');
    const [triggers, setTriggers] = useState<string[]>(
        customTriggerId ? customTriggerId.split("|").map(s => s.trim()).filter(Boolean) : [""]
    );

    // Show information popup
    const [isShowInfoModal, setIsShowInfoModal] = useState<boolean>(false);

    const [errorMessage, setErrorMessage] = useState<string>('');

    // Set current widget icon type
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if custom trigger is turned On
            if (currentWebsite.is_custom_trigger) {
                setCustomTrigger(currentWebsite.is_custom_trigger);
            }
            if (currentWebsite.custom_trigger_id) {
                setCustomTriggerId(currentWebsite.custom_trigger_id);
            }
        }
    }, [currentWebsite]);



    // set current statement link in prop function
    useEffect(() => {
        setIsChangeCustomTrigger(customTrigger);
    }, [customTrigger]);


    useEffect(() => {
        if (customTriggerId) {
            setChangeCustomTriggerId(customTriggerId)
        }
    }, [customTriggerId]);


    const validateId = (id: string) => {
        setCustomTriggerId(id);
        // let filteredId = id.replace(/^([#.])/, '');


        // const regx = /^[A-Za-z][A-Za-z0-9\-\_\:\.]*$/;

        // if (regx.test(filteredId)) {
        //     setErrorMessage("");
        // }
        // else {
        //     setErrorMessage(t("Invalid Id Error"));
        // }
        

    }

      useEffect(() => {
        // whenever triggers change, join them with | and send to parent
        const joined = triggers.filter(Boolean).join("|");
        setChangeCustomTriggerId(joined);
    }, [triggers, setChangeCustomTriggerId]);

    const handleChange = (value: string, index: number) => {
        const updated = [...triggers];
        updated[index] = value;
        setTriggers(updated);
    };

    const handleAdd = () => {
        if (triggers.length < 4) {
        setTriggers([...triggers, ""]);
        }
    };

    const handleDelete = (index: number) => {
        const updated = triggers.filter((_, i) => i !== index);
        setTriggers(updated.length > 0 ? updated : [""]); // keep at least one input
    };

     // function to show information modal
    const handleShowInfoModal = (type: number) => {
        setIsShowInfoModal(true);
    }

    // function to hide information modal
    const handleHideInfoModal = () => {
        setIsShowInfoModal(false);
    }


    return (
        <>
            <div className="aioa_dashboard-widget-settings-controls">
                <div className={customTrigger ? "aioa_dashboard-widget-custom-settings border-bottom" : ''}>
                    <Form.Check
                        type="switch"
                        className="aioa_dashboard-switch"
                        id="custom-trigger-switch"
                        label={`${t('Enable Custom Accessibility Trigger')}`}
                        checked={customTrigger}
                        onChange={(e) => setCustomTrigger(!customTrigger)}
                    />
                </div>
                {customTrigger ?
                    <>
                        {triggers.map((trigger, index) => (
                            <Form.Group
                            key={index}
                            className="custom-statement mt-3 align-middle"
                            controlId={`custom_accessibility_trigger_id_${index}`}
                            >
                            <Form.Label>
                                {t("Enter a custom accessibility trigger using an ID, selector, or XPath.")} {index + 1}
                            </Form.Label>
                            <Button
                                variant="link"
                                className="info-btn"
                                aria-label={t("Learn more about Custom Accessibility Trigger").toString()}
                                onClick={() => handleShowInfoModal(3)}
                            >
                                <i className="material-symbols-outlined" aria-hidden="true">info</i>
                            </Button>

                            <div className="d-flex gap-2 align-items-center">
                                <Form.Control
                                size="lg"
                                type="text"
                                placeholder={t("Custom Trigger Id")}
                                value={trigger}
                                onChange={(e) => handleChange(e.target.value, index)}
                                />
                                {triggers.length > 1 && (
                                <Button
                                    variant="danger"
                                    className="h-50"
                                    onClick={() => handleDelete(index)}
                                    aria-label={t("Delete Trigger")}
                                >
                                    ✕
                                </Button>
                                )}
                            </div>
                            </Form.Group>
                        ))}

                        {triggers.length < 4 && (
                            <Button variant="primary mt-2" onClick={handleAdd}>
                            + {t("Add Trigger")}
                            </Button>
                        )}
                    </>
                    : <></>
                }
                {/* Show Info Modal */}
                <Modal show={isShowInfoModal} onHide={() => handleHideInfoModal()} fullscreen="sm-down" backdrop="static" centered>
                    <Modal.Header closeButton>
                    <Modal.Title>
                        <>{t('Custom Accessibility Trigger')}</>
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t('Enter a custom trigger identifier that can be:')}</p>
                        <ul>
                        <li>{t('An')} <strong>{t('ID')}</strong> ({t('e.g')}, <code>my-button</code>)</li>
                        <li>{t('A')} <strong>{t('CSS selector')}</strong> ({t('e.g')}, <code>.my-class</code>)</li>
                        <li>{t('An')} <strong>{t('XPath')}</strong> ({t('e.g')}, <code>//button[@id='my-button']</code>)</li>
                        </ul>
                    </Modal.Body>
                </Modal>

            </div>
        </>
    )
}

export default CustomTrigger;